import { memo } from 'react';

import {
  BtnGroup,
  BtnToolbar,
  Button,
  ButtonAction,
  Datepicker,
  type HookFormMethods,
  HookFormResolver,
  Row
} from '@dec/shared';
import { useTranslation } from 'react-i18next';

import { type PaymentFilterForm } from './search';

interface DisbursementFiltersProps {
  onSearch: (values: PaymentFilterForm) => void;

  onClear: () => void;
}

export const DisbursementFilters = memo(({ onSearch, onClear }: DisbursementFiltersProps) => {
  const { t } = useTranslation();

  const handleClear = (reset: HookFormMethods['reset']) => {
    reset({});

    onClear();
  };

  return (
    <HookFormResolver onSubmit={onSearch}>
      {({ reset }: HookFormMethods) => (
        <>
          <Row>
            <div className="col-12 col-sm-6 col-lg-3">
              <Datepicker label={t('common.label.dateFrom')} name="dateFrom" />
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <Datepicker label={t('common.label.dateTo')} name="dateTo" />
            </div>
          </Row>

          <BtnToolbar>
            <BtnGroup>
              <Button
                action={ButtonAction.clean}
                variant="secondary"
                type="reset"
                onClick={() => handleClear(reset)}
              />
            </BtnGroup>

            <BtnGroup>
              <Button action={ButtonAction.find} type="submit" variant="primary" />
            </BtnGroup>
          </BtnToolbar>
        </>
      )}
    </HookFormResolver>
  );
});

DisbursementFilters.displayName = 'DisbursementFilters';
